import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'a1-message',
  styleUrl: 'a1-message.scss',
  scoped: true,
})
export class A1Message {
  /**
   * Text for the message.
   */
  @Prop({ reflect: true }) text!: string;

  /**
   * Define the message type.
   */
  @Prop({ reflect: true }) type: 'critical' | 'warning' | 'positive' | 'info' = 'info';

  render() {
    const classes = {
      [this.type]: true,
    };

    return (
      <div class={{ message: true, ...classes }}>
        <span class="icon" aria-hidden="true"></span>
        <span>{this.text}</span>
      </div>
    );
  }
}
